// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assessment-container {
  display: block;
  justify-content: center;
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
.assessment-container .original-obs {
  width: 100%;
}
.assessment-container .gap {
  padding-bottom: 10px;
}
.assessment-container .actions {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.assessment-container .actions .actions-buttons {
  display: flex;
  text-align: center;
  padding-top: 20px;
}
.assessment-container .actions .actions-buttons .action-button {
  width: 170px;
  margin-right: 10px;
}
@media (max-width: 650px) {
  .assessment-container .actions .actions-buttons {
    flex-direction: column;
    width: 100%;
  }
  .assessment-container .actions .actions-buttons .action-button {
    margin-right: 0;
    margin-bottom: 10px;
    width: 100%;
  }
}
.assessment-container .legend {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 30px;
  margin-bottom: 10px;
  justify-content: left;
}
.assessment-container .legend .legend-text {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #efefef;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 20px;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  height: 20vw;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/intern/obs-assessment/obs-assessment.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AACJ;AACI;EACI,WAAA;AACR;AAEI;EACI,oBAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AADR;AAGQ;EACI,aAAA;EACA,kBAAA;EACA,iBAAA;AADZ;AAGY;EACI,YAAA;EACA,kBAAA;AADhB;AAKQ;EACI;IACE,sBAAA;IACA,WAAA;EAHZ;EAKY;IACE,eAAA;IACA,mBAAA;IACA,WAAA;EAHd;AACF;AAQI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AANR;AAQQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AANZ;;AAWA;EACI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AARJ","sourcesContent":[".assessment-container {\n    display: block;\n    justify-content: center;\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n\n    .original-obs {\n        width: 100%;\n    }\n\n    .gap {\n        padding-bottom: 10px;\n    }\n\n    .actions {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n\n        .actions-buttons {\n            display: flex;\n            text-align: center;\n            padding-top: 20px;\n\n            .action-button {\n                width: 170px;\n                margin-right: 10px;\n            }\n        }\n\n        @media (max-width: 650px) {\n            .actions-buttons {\n              flex-direction: column;\n              width: 100%;\n          \n              .action-button {\n                margin-right: 0;\n                margin-bottom: 10px;\n                width: 100%;\n              }\n            }\n        }\n    }\n\n    .legend {\n        display: flex;\n        flex-direction: row;\n        width: 100%;\n        margin-top: 30px;\n        margin-bottom: 10px;\n        justify-content: left;\n\n        .legend-text {\n            display: flex;\n            flex-direction: column;\n            width: 100%;\n            background-color: #efefef;\n            padding-top:10px;\n            padding-left: 10px; \n            padding-bottom: 20px;\n        }\n    }\n}\n\n.loading-spinner {\n    display: flex;\n    justify-content: center;\n    height: 20vw;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
